import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

interface SectionTitleProps {
  title: string;
  subTitle: string;
}

export const SectionTitle = ({ title, subTitle }: SectionTitleProps) => {
  return (
    <>
      <Title className={Typography.BODY_18_SEMIBOLD}>{title}</Title>
      <SubTitle className={Typography.BODY_13_REGULAR}>{subTitle}</SubTitle>
    </>
  );
};

export const Title = styled.p`
  color: ${vars.v3Color.gray950};
`;

export const SubTitle = styled.p`
  margin: 8px 0 15px;
  color: ${vars.v3Color.gray600};
`;
